var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUdstilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.045,9.393a.684.684,0,0,0-1.367,0,.667.667,0,0,0,.139.392,2.176,2.176,0,0,1-1.823.881,2.3,2.3,0,0,1-1.711-.8A.685.685,0,1,0,7.3,9.856a2.172,2.172,0,0,1-1.766.81A2.325,2.325,0,0,1,3.762,9.8a.669.669,0,0,0,.15-.41.683.683,0,1,0-1,.6.327.327,0,0,0-.018.089V12.6a.336.336,0,0,0,.671,0V10.554a2.886,2.886,0,0,0,1.967.783,2.87,2.87,0,0,0,1.928-.685V12.6a.336.336,0,0,0,.671,0V10.652a2.889,2.889,0,0,0,1.863.685,2.835,2.835,0,0,0,2.032-.785V12.6a.336.336,0,0,0,.671,0V10.078a.327.327,0,0,0-.018-.089A.679.679,0,0,0,13.045,9.393Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.352,7.982h7.16a.335.335,0,0,0,.335-.335V3a.335.335,0,0,0-.335-.336H4.352A.335.335,0,0,0,4.017,3V7.647A.335.335,0,0,0,4.352,7.982ZM4.688,3.33h6.488V7.311H4.688Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdstilling);
export default __webpack_public_path__ + "static/media/UDSTILLING.19814b018eeb16af6ee495406d75b338.svg";
export { ForwardRef as ReactComponent };